<template>
  <div>
    <div class="flex flex-wrap items-center gap-3">
      <div class="grow truncate">
        <AppLink
          v-if="!disabled"
          :to="{
            name: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
            params: { project_id: unit.attributes.project_id, level_type: unit.type, level_id: unit.id },
          }"
        >
          <TitleSmall>
            {{ is_SUP ? project.attributes.name : unit.attributes.name }}
          </TitleSmall>
        </AppLink>
        <div v-else>
          <TitleSmall>
            {{ is_SUP ? project.attributes.name : unit.attributes.name }}
          </TitleSmall>
        </div>
        <h6
          v-if="disabled"
          class="subtitle is-6 truncate italic"
        >
          {{ $t('project.labels.noAccess') }}
        </h6>
        <h6
          v-else-if="!is_SUP"
          class="subtitle truncate text-sm"
        >
          {{ project.attributes.name }}
        </h6>
      </div>
      <div
        v-if="group_customer.attributes.scope === GroupCustomer.SCOPE_VISIBLE"
        class="tag rounded-full"
      >
        {{ is_SUP ? $t('unit.labels.scopes.visible_SUP') : $t('unit.labels.scopes.visible') }}
      </div>
      <div
        v-if="group_customer.attributes.scope === GroupCustomer.SCOPE_INVISIBLE"
        class="tag rounded-full"
      >
        {{ is_SUP ? $t('unit.labels.scopes.invisible_SUP') : $t('unit.labels.scopes.invisible') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { ROUTES_EMPLOYEES } from '@/app/data/route_constants';
import { GroupCustomer, PROJECT_TYPES } from '@/app/data/model_constants';

const props = defineProps({
  group_customer: { type: Object, required: true },
  project: { type: Object, default: null },
  unit: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
});

const store = useStore();

const current_client = computed(() => store.getters.current_client);
const is_SUP = computed(() => current_client.value.attributes.project_type === PROJECT_TYPES.SUP);
</script>
